import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Breaking bounds with BoundBreaker",
  "description": "",
  "published": "2013-02-19T00:00:00.000Z",
  "redirect_from": ["/blog/breaking-bounds-with-boundbreaker/swizec/6003"],
  "categories": "Silicon Valley, Slovenia, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Remember to clench your butt.`}</p>
      <p parentName="blockquote">{`~ the single most useful piece of advice I've ever gotten, by `}<a parentName="p" {...{
          "href": "https://twitter.com/filipdobranic"
        }}>{`@filipdobranic`}</a>{` of BoundBreaker`}</p>
    </blockquote>
    <p>{`Back in 2009 I was a greenhorn entrepreneur. Not that I'm an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Entrepreneur",
        "title": "Entrepreneur"
      }}>{`entrepreneurial`}</a>{` machine pumping out product after product these days, but at least I'm not flopping about like a fish out of water.`}</p>
    <p>{`Most of the time.`}</p>
    <p>{`But I did start my first startup in 2009, two weeks before my 22nd birthday. At the time I was still practically a freshman at college and had just quit my job as a run-of-the-mill web developer building crappy websites for an advertising/communications agency. Of course I had no funds and no idea what I was doing.`}</p>
    <p>{`But hey, I was a hacker and a decent programmer, just how hard can it be to learn how to business? Piece of cake! I'll learn it in a weekend just like I did python!`}</p>
    <p>{`Turns out it's not that easy. Hell, I didn't even know how to incorporate or that it might be a good idea.`}</p>
    <p>{`Luckily I met the guys from `}<a parentName="p" {...{
        "href": "http://www.boundbreaker.org/"
      }}>{`BoundBreaker`}</a>{`. Sure, there was no BoundBreaker when I met them, but in summer of 2010 my team and I became part of their first generation of hackerpreneurs running startups.`}</p>
    <h2 {...{
      "id": "boundbreaker"
    }}>{`BoundBreaker`}</h2>
    <p>{`It's hard to say whether being part of an accelerator, any accelerator, is better than learning everything on your own or not - especially since I can't really compare - but it does teach you things you otherwise wouldn't think of learning. That's the main benefit of having mentors really - autodidactism only gets you so far.`}</p>
    <p>{`Public speaking skills are a perfect example of this. Very few hackers invest in learning how to speak in front of a crowd. Just go to project presentations at your local computer science faculty. It's a mess.`}</p>
    <p>{`Giving my first or second talk, I walked up on stage. I've got this! Always been good with words and I'm a master of improvisation in tough situations!`}</p>
    <p>{`The 30 minute talk was over in 5 minutes ... `}<em parentName="p">{`"Uhhh, you guys know what I was trying to say, right? You're itching to download this app I've built, aren't you?"`}</em></p>
    <p>{`Nowadays I can walk up on stage and it's as relaxing as sitting at home, watching my favourite TV show. It really is quite an amazing transformation.`}</p>
    <p>{`And I don't have just the sheer amount of practice to thank, part of the BoundBreaker deal was to teach me how to present ideas anywhere at any time. Just go up there and wow the audience into thinking my idea is the best thing since sliced toast with mozzarella.`}</p>
    <p>{`Just clench your butt!`}</p>
    <p>{`That's all you need to know when faced with a room full of scary looking investors after you've bet the proverbial farm on making this meeting work out in your favour.`}</p>
    <p>{`Public speaking isn't all BoundBreaker's taught me though, there was a bunch of other things too. I learned all about the `}<a parentName="p" {...{
        "href": "http://www.startuplessonslearned.com/2008/09/lean-startup.html",
        "title": "Lean Startup"
      }}>{`lean startup`}</a>{` model, launching MVP's, testing assumptions ... things about vesting and a bunch of things about running a team.`}</p>
    <p>{`Turns out, if it takes six months to build it's probably not a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Minimum_viable_product",
        "title": "Minimum viable product"
      }}>{`minimum viable product`}</a>{`. That lesson took so long to sink in my startup fizzled out in the process. Ooops.`}</p>
    <p>{`However, that summer culminated in my first trip to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.37,-122.04&spn=1.0,1.0&q=37.37,-122.04%20(Silicon%20Valley)&t=h",
        "title": "Silicon Valley"
      }}>{`Silicon Valley`}</a>{`!`}</p>
    <p>{`The BoundBreaker team organised most of everything to do with the trip so we could focus on scoring meetings with investors and other persons of interest. It's amazing, but a scrappy startup from Slovenia can totally get to a serious meeting with the founder of a VC fund after spending just two weeks in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{` and talking to people.`}</p>
    <p>{`Shame I didn't take `}<a parentName="p" {...{
        "href": "https://twitter.com/kristjanp"
      }}>{`@kristjanp`}</a>{`'s advice to stay in Palo Alto and seriously put together an investment round after we got the first VC to bite ... but alas, mentors can only give suggestions, they can't run the business for you.`}</p>
    <p>{`You should `}<a parentName="p" {...{
        "href": "http://www.boundbreaker.org/apply/"
      }}>{`apply to BoundBreaker`}</a>{` ;)`}</p>
    <p>{`PS: they even bought me a cake on my 23rd birthday while we were in the US!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.hiscoxusa.com/small-business-insurance/blog/2011/09/23/my-startup-story-pete-cashmore-founder-and-ceo-of-mashable/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_103_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.hiscoxusa.com/small-business-insurance/blog/2011/09/23/my-startup-story-pete-cashmore-founder-and-ceo-of-mashable/"
        }}>{`#MyStartupStory: Pete Cashmore, Founder and CEO of Mashable`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.slideshare.net/HackerChick/lean-startup-101-16313871"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/142743624_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.slideshare.net/HackerChick/lean-startup-101-16313871"
        }}>{`Lean Startup 101`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=56ccf3f0-0280-4951-b66c-aa7c00af80da",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      